module.exports = __webpack_public_path__ + "static/assets/f56033dd9db0150762c6acb792816ac9.png";